<template>
  <modal
    height="400px"
    @close="$emit('close')"
    @neutralButtonClick="$emit('close')"
    @positiveButtonClick="save"
    :neutral-button-text="$t('action.cancel')"
    :positive-button-text="modalAction === 'add' ? $t('general.add') : $t('action.save')"
    :title="$t('campaignDesigner.targetDefinition.ruleGroup')">

    <div>
      <Input :label="$t('campaignDesigner.targetDefinition.segmentName')" :validation="['required']" ref="newGroup_name" v-model="segmentName" />

      <div class="slds-grid slds-p-top--small">
        <radio-group
          class="slds-col slds-size--1-of-2"
          no-label
          ref="newGroup_operator"
          :validation="['required']"
          :options="operators"
          v-model="operator" />

        <logic-icon class="slds-col slds-size--1-of-2" :operator="operator" />
      </div>
    </div>
  </modal>
</template>
<script>
import { validate } from '../../../utils/utils'
import Input from '../../../slds/Input'
import LogicIcon from './LogicIcon'
import Modal from '../../../Modal'
import RadioGroup from '../../../slds/RadioGroup'
import { mapActions } from 'vuex'
export default {
  name: 'NewGroupModal',
  components: {
    Input,
    LogicIcon,
    Modal,
    RadioGroup
  },
  props: {
    config: Object,
    group: Object,
    modalAction: String
  },
  data () {
    return {
      operator: '',
      operators: [
        {
          label: this.$t('operators.AND'),
          value: 'AND'
        },
        {
          label: this.$t('operators.OR'),
          value: 'OR'
        },
        {
          label: this.$t('operators.NOT'),
          value: 'NOT'
        }
      ],
      segmentName: ''
    }
  },
  methods: {
    save () {
      const valid = validate(this, 'newGroup_', true)
      if (valid) {
        const payload = {
          segmentName: this.segmentName,
          operator: this.operator
        }
        if (this.modalAction === 'add') {
          this.$emit('newGroup', payload)
        } else {
          this.$emit('editGroup', payload)
        }
        this.$emit('close')
      }
    }
  },
  async created () {
    if (this.modalAction === 'edit') {
      this.action = 'group'
      this.operator = this.group.operator
      this.segmentName = this.group.segmentName
    }
  }
}
</script>
<style lang="scss" scoped>
  .delete-button {
    color: #C23933;
    align-self: flex-end;
  }

  .row {
    display: flex;
    flex-direction: row;
  }
</style>
